import { render, staticRenderFns } from "./editClient.vue?vue&type=template&id=08d2b6d0"
import script from "./editClient.vue?vue&type=script&lang=js"
export * from "./editClient.vue?vue&type=script&lang=js"
import style0 from "./editClient.vue?vue&type=style&index=0&id=08d2b6d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports